__turbopack_context__.v({
  "lds-roller": "style-module__0UiaAa__lds-roller",
  "spinner": "style-module__0UiaAa__spinner",
});
